export const scrollingTextItems = [
  'Layer-1 Blockchain (DPoS)',
  'e-Commerce Trading Portal',
  'Real Estate Trading Portal',
  'Luxury Lifestyle Booking Portal',
  'Universal Payment Gateway',
  'Intellectual Property (IP) Blockchain Co-ownership',
  'Tap-2-Mine (PoI Mining)',
  'SEAV Protocol (Self-Earning Asset Vault)',
  'CratSwap V3 (DEX)',
  'Staking Protocol',
  'Smart-CratSwap',
  'Multi-Chain Bridge',
  'MainNet Explorer',
];
